import React from "react";

const CustomButton = ({
  type = "submit",
  style,
  children,
  className,
  onClick = () => {},
  disabled,
}) => {
  return (
    <button
      disabled={disabled}
      style={style}
      type={type}
      onClick={onClick}
      className={` px-3.5 h-[44px] bg-primary hover:bg-primary/70 duration-300 rounded-[10px]  font-medium text-[13px] text-white flex items-center justify-center ${className} disabled:opacity-70 disabled:cursor-not-allowed text-nowrap`}
    >
      {children}
    </button>
  );
};

export default CustomButton;
